const CUSTOMILY_PERSONALISE_HASH = '#personalise=customily'
const CUSTOMILY_MODAL_SHOW_EVENT = 'customily-modal-show'
const CUSTOMILY_AFTER_MODAL_SHOW_EVENT = 'customily-after-modal-show'

class CustomilyPersonalisation {
  constructor () {
    this.originalAddEventListener = null

    this.onModalShow = this.onModalShow.bind(this)
  }

  initialise () {
    if (!this.shouldOpen) return

    window.addEventListener(
      CUSTOMILY_AFTER_MODAL_SHOW_EVENT,
      this.onModalShow,
      { once: true },
    )

    this.watchForCustomily()
  }

  get shouldOpen () {
    return window.location.hash === CUSTOMILY_PERSONALISE_HASH
  }

  watchForCustomily () {
    this.originalAddEventListener = window.addEventListener

    window.addEventListener = (type, listener, options) => {
      this.originalAddEventListener.call(window, type, listener, options)

      if (type !== CUSTOMILY_MODAL_SHOW_EVENT) return

      this.restoreAddEventListener()

      queueMicrotask(() => {
        this.openCustomily()
      })
    }

    /*
     * Customily may already be ready by the time this script initialises.
     * If so, this will open the modal immediately. Otherwise, the listener
     * above waits for Customily to register its modal event handler.
     */
    this.openCustomily()
  }

  openCustomily () {
    window.dispatchEvent(new CustomEvent(CUSTOMILY_MODAL_SHOW_EVENT))
  }

  onModalShow () {
    this.restoreAddEventListener()
    this.removeHash()
  }

  restoreAddEventListener () {
    if (!this.originalAddEventListener) return

    window.addEventListener = this.originalAddEventListener
    this.originalAddEventListener = null
  }

  removeHash () {
    const url = new URL(window.location.href)

    url.hash = ''

    window.history.replaceState({}, '', url)
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const customilyPersonalisation = new CustomilyPersonalisation()

  customilyPersonalisation.initialise()
})
